<script setup>
definePageMeta({
  layout: "blog",
  middleware: ["blog"]
});

const route = useRoute()
const { getBlogSettings, getPostBySlug, getPrevPost, getNextPost } = useBlogData()
const { setPageHead } = useGlobalFeaturesData();

// Getting the post
// const { data: post, error } = await getPostBySlug(route.params.slug)
const post = route.params.post;
const { data: settings, error: settingsError } = await getBlogSettings()

// if (error.value) {   
//   throw createError(error.value)
// }

// Sections dynamic builder variable
const sections = post.value && post.value.blocks ? post.value.blocks : []
// Sections dynamic builder bottom variable
const sections_bottom = post.value && post.value.blocks_bottom ? post.value.blocks_bottom : []

// Next and prev posts
const { data: prevP } = await getPrevPost(post.value.publishedAtRaw)
const { data: nextP } = await getNextPost(post.value.publishedAtRaw)

// Get only the next/prev data
let nextPost = nextP.value && nextP.value.data[0] ? nextP.value.data[0] : null, prevPost = prevP.value && prevP.value.data[0] ? prevP.value.data[0] : null

// Set meta tags in head for SEO
if (post.value && post.value.seo) {
  setPageHead(post.value.seo, route.path);
}

// // Jump to top option
const displayJumpToTop = post.value.jumpToTop;

let authorLink = ``
if (!!post.value.author){
  authorLink = `/blog/authors/${post.value.author.slug}`
}

// Improvement needed: Another validation is required, in case boltImage field is empty a placeholder image should be shown
const featuredImage = post.value.image !== null && post.value.image.data !== null ? post.value.image.url : post.value.boltImage;


let breadcrumb = route.params.breadcrumb ? route.params.breadcrumb : ''

let breadcrumbHref = ''

if (!!breadcrumb && !!breadcrumb.label){
  breadcrumbHref = `/blog/${breadcrumb.type}/${breadcrumb.slug}`
}
</script>

<template>
  <BlogCategories />
  <section class="blog-page">
    <div class="container g-0">
      <div class="row g-0">
        <section class="col-12 col-lg-8">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="breadcrumb">
                  <a class="breadcrumb-element" :href="`/blog`">Blog</a>

                  <span class="breadcrumb-element" v-if="breadcrumb.label">></span>
                  <a class="breadcrumb-element" v-if="breadcrumb.label" v-html="breadcrumb.label" :href="breadcrumbHref"></a>

                  <span class="breadcrumb-element">></span>
                  <span class="breadcrumb-element" v-html="post.title"></span>
                </div>
                <h1 v-html="post.title"></h1>
                <div class="row align-items-center">
                  <div class="col-12 col-lg-6">
                    <a v-if="!!post.author" class="author-link" :href="authorLink" :title="post.author.name">{{ post.author.name }}</a>
                    <br v-if="!!post.author">
                    <span class="published-date">{{ post.publicationDate ?  post.publicationDate : post.publishedAt }}</span>
                  </div>
                  <div class="col-12 col-lg-6">
                    <BlogSocialShare :class="'justify-content-lg-end'" />
                  </div>
                </div>
                <NuxtImg :src="featuredImage" class="featured-image" />
              </div>
            </div>
          </div>
          <!-- Dynamic blocks -->
          <LayoutDynamicComponents :id="'dynamic-zone'" v-if="sections" :sections="sections"/>
        </section>
        <section class="col-12 col-lg-4 d-none d-lg-block">
          <BlogPostFeatured :featuredPosts="settings.featuredPosts"/>
          <FloatingBlockLeadGen v-if="post.displayFloatingBlock" :blog="post" />
        </section>
      </div>
    </div>
    <!-- Bottom of the page -->
    <div class="container mb-5">
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="share-bottom">
            <b class="share-bottom-title">Share to</b>
            <BlogSocialShare />
          </div>
          <section class="author-section" v-if="!!post.author">
            <a class="row author-container" :href="authorLink">
              <div class="col-12 col-lg-3">
                <div :style="`background-image: url(${post.author.image.data.attributes.url})`" class="author-image"></div>
              </div>
              <div class="col-12 col-lg-8">
                <article class="author-bio">
                  <div class="author-name" v-html="post.author.name"></div>
                  <div class="author-background" v-html="post.author.background"></div>
                </article>
              </div>
              <div class="col-12 col-lg-1">
                <div class="icon-container">
                  <i class="icon-chevron-right"></i>
                </div>
              </div>
            </a>
          </section>
        </div>
      </div>
    </div>
    <div class="container next-prev-posts">
      <div class="row align-items-stretch">
        <div class="col-12 col-lg-4">
          <a v-if="prevPost != null" :href="`/blog/${prevPost.slug}`" class="next-prev-container prev-container">
            <div class="icon-container">
              <i class="icon-chevron-left"></i>
            </div>
            <div class="post-title">
              <div class="small-indicator">Prev post</div>
              <b v-html="prevPost.title"></b>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-4 offset-lg-4">
          <a v-if="nextPost != null" :href="`/blog/${nextPost.slug}`" class="next-prev-container next-container">
            <div class="post-title">
              <div class="small-indicator">Next post</div>
              <b v-html="nextPost.title"></b>
            </div>
            <div class="icon-container">
              <i class="icon-chevron-right"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="container mb-5" v-if="!!post.relatedPosts && post.relatedPosts.length > 0">
      <div class="row">
        <div class="col-12">
          <BlogPostRelated :relatedPosts="post.relatedPosts"/>
        </div>
      </div>
    </div>
    <section class="col-12 d-lg-none">
      <BlogPostFeatured :featuredPosts="settings.featuredPosts"/>
      <FloatingBlockLeadGen v-if="post.displayFloatingBlock" :blog="post" />
    </section>
    <!-- Dynamic blocks_botom -->
    <div class="container">
      <div class="row">
        <div class="col-12">
          <LayoutDynamicComponents :id="'dynamic-zone-2'" v-if="sections_bottom" :sections="sections_bottom"/>
        </div>
      </div>
    </div>
  </section>
  <LayoutBackToTop v-if="displayJumpToTop" />
</template>

<style lang="scss">
.blog-page{
  .breadcrumb{
    font-size: $font-size-smaller;
    a{
      font-weight: bold;
    }
    .breadcrumb-element{
      color: $color-primary;
      display: inline-block;
      &:not(:last-child){
        margin-right: 10px;
      }
    }
  }
  .author-link{
    color: $color-primary;
    font-weight: bold;
  }
  .published-date{
    display: block;
    margin-bottom: 10px;
  }

  .featured-image{
    border-radius: 12px;
    margin: 20px auto 10px;
    max-width: 100%;
    display: block;
  }

  .short-description{
    color: $color-body-text;
  }

  .share-bottom{
    margin-bottom: 40px;
    .share-bottom-title{
      display: block;
      margin-bottom: 14px;
    }
  }
  
  .author-section{
    color: $color-body-text;
    .author-container{
      display: flex;
      flex-wrap: wrap;
      --bs-gutter-x: 1.5rem;
      --bs-gutter-y: 0;
      border-radius: 24px;
      background: $color-lightest-gray;
      color: $color-body-text;
      text-decoration: none;
      &:hover{
        text-decoration: none;
        font-weight: 400;
        .author-background{
          font-weight: 400;
        }
      }
    }
    .author-image{
      width: 108px;
      height: 108px;
      background: no-repeat center;
      background-size: cover;
      border-radius: 50%;
      margin: 10px auto 26px;
      display: block;
    }
    .author-bio{
      text-align: center;
      margin-top: 10px;
      margin-bottom: 10px;
      .author-name{
        font-weight: bold;
      }
      .author-background{
        p:last-child{
          margin: 0;
        }
      }
    }
    .icon-container{
      margin: 10px auto 20px;
      text-align: center;
      font-size: 24px;
      line-height: 24px;
    }
  }

  .next-prev-posts{
    margin-top: 40px;
    margin-bottom: 40px;
    .next-prev-container{
      text-decoration: none;
      color: $color-body-text;
      background: $color-lightest-gray;
      border-radius: 16px;
      padding: 10px 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:hover{
        .small-indicator{
          font-weight: 400;
        }
      }
      &.prev-container{
        text-align: right;
        .post-title{
          margin-left: 35px;
        }
      }
      &.next-container{
        text-align: left;
        .post-title{
          margin-right: 35px;
        }
      }
      .small-indicator{
        font-size: $font-size-tiny;
        text-transform: uppercase;
      }
      .icon-container{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: center;
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
  .featured-posts{
    margin-left: 10px;
    margin-right: 10px;
  }
  .floating-wrapper{
    width: calc(100% - 40px)
  }

  @include media-breakpoint-up(lg){
    .breadcrumb{
      font-size: $font-size-small;
    }
    .author-section{
      .author-image{
        margin-bottom: 10px;
      }
      .icon-container{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }
    .next-prev-posts{
      .next-prev-container{
        height: 100%;
      }
    }
  }
}
</style>
